import { CommonConfigInterface, InputConfiguration } from "interfaces/common";

const defaultTitles = ["mr", "ms", "divers", "none"];

const defaultInputConfiguration: InputConfiguration = {
  floatingLabel: false,
  optionalToolTip: true,
  mandatoryAsterisk: false,
  showDeleteIcon: false,
};

const defaultValidationConfig = {
  phoneNumber: /^[0-9]{1,14}$/,
  namePassengers: /^[-A-Za-zÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ ]*$/,
  nameBilling: /^[-A-Za-zÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ ]*$/,
  fqtvNumber: /^[a-zA-Z0-9]{8,15}$/,
  bankAccountHolder: /^[a-zA-Z0-9]{8,15}$/,
  bankAccountNumber: /^[0-9A-Z]{22}$/,
  city: /^[-A-Za-zÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ ]*$/,
  addressData: /^[-A-Za-z0-9ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ .]*$/,
  postcode: /^[A-Za-z0-9- ]*$/,
  email: /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+)@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})$/
}

const ewgValidationConfig: Record<string, RegExp> = {
  phoneNumber: /^\d{2,19}$/,
  namePassengers: /^[\p{L}\p{M}'\s\-]{0,29}$/u,
  nameBilling: /^[\p{L}\p{M}'\s\-]{0,31}$/u,
  fqtvNumber: /^[a-zA-Z0-9]{8,15}$/,
  cardHolder: /^[0-9A-Za-z\s\-+\/]{6,30}$/,
  bankAccountHolder: /^[0-9A-Za-z\s\-+\/]{6,30}$/,
  bankAccountNumber: /^[A-Z]{2}[0-9A-Z]{13,30}$/,
  city: /^[\p{L}\p{M}\s.\-]{2,32}$/u,
  addressData: /^[\p{L}\p{M}\p{N}\s.,#\/\-]{2,128}$/u,
  postcode: /^[a-zA-Z0-9 \-]{2,10}$/,
  email: /^[\p{L}\p{M}\p{N}.!#$%&'+\/=?^_`{|}~\-]+@[\p{L}\p{M}\p{N}](?:[\p{L}\p{M}\p{N}\-]{0,61}[\p{L}\p{M}\p{N}])?(?:\.[\p{L}\p{M}\p{N}](?:[\p{L}\p{M}\p{N}\-]{0,61}[\p{L}\p{M}\p{N}])?)$/u
};

const defaultConfig: CommonConfigInterface[string] = {
  titles: defaultTitles,
  hasVouchers: false,
  input: defaultInputConfiguration,
  preservePaxs: false,
  validationConfig: defaultValidationConfig
};

const lxsLhsInputConfig: InputConfiguration = {
  floatingLabel: true,
  optionalToolTip: true,
  hideOptionalOnNotEmpty: true,
  mandatoryAsterisk: true,
  showDeleteIcon: true,
  noFormatOnEmpty: true,
}

const ewgConfig: CommonConfigInterface[string] = {
  titles: ["mr", "mrs","divers"],
  hasVouchers: false,
  input: defaultInputConfiguration,
  hasAsterisk: true,
  validationConfig: ewgValidationConfig
};

const configuration: CommonConfigInterface = {
  ewg: ewgConfig,
  ald: {
    ...ewgConfig,
    hasVouchers: true,
  },
  lhs: {
    titles: defaultTitles,
    hasVouchers: false,
    input: lxsLhsInputConfig,
    preservePaxs: true,
    emptyTopLabel: {
      textId: "",
    },
    validationConfig: defaultValidationConfig
  },
  oss: {
    titles: defaultTitles,
    hasVouchers: false,
    input: {
      ...defaultInputConfiguration,
      floatingLabel: true,
      mandatoryAsterisk: true,
      optionalToolTip: false,
    },
    emptyTopLabel: {
      textId: "",
    },
    preservePaxs: true,
    validationConfig: defaultValidationConfig
  },
  sns: {
    ...defaultConfig,
    defaultLang: "en",
    input: {
      floatingLabel: true,
      optionalToolTip: false,
      mandatoryAsterisk: true,
    },
    emptyTopLabel: {
      textId: "",
    },
    preservePaxs: true
  },
  lxs: {
    ...defaultConfig,
    defaultLang: "en",
    input: lxsLhsInputConfig,
    emptyTopLabel: {
      textId: "",
    },
    preservePaxs: true
  },
  default: defaultConfig,
};

export default configuration;
